<mat-toolbar #toolBarOrigin="cdkOverlayOrigin" cdkOverlayOrigin class="topbar telative" color="primary">
  <!-- ============================================================== -->
  <!-- app application-header component - style you can find in application-header.scss / user-config-header.component.ts-->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Sidebar toggle-->
  <!-- ============================================================== -->
  @if (!data?.hideSidenav) {
    <button (click)="toggleSideNav()" [matTooltip]="'TOOLTIP.SIDEBAR' | translate"
            class="snav-btn" mat-icon-button>
      <mat-icon fontSet="mdi" fontIcon="mdi-menu" class="sidenav-icon"></mat-icon>
    </button>
  }
  <!-- ============================================================== -->
  <!-- Logo - organization name -->
  <!-- ============================================================== -->
  <div class="navbar-header fx-layout-row fx-justify-start fx-align-center">
    <a [routerLink]="[homePage$ | async]" class="navbar-brand" (click)="onNavigation('TITLE.HOME')">
      <!-- Logo icon -->
      <img alt="mya" class="mya-logo" ngSrc="assets/images/mya_icon.svg" height="16" width="16" priority>
    </a>
  </div>
  <!-- ============================================================== -->
  <!-- Extensible separator between headers to keep them at each end  -->
  <!-- ============================================================== -->
  <span class="navbar-organization-info fx-flex-grow fx-justify-start">
    <!-- Organization name hidden on TB Dashboard to avoid displaying it after an organization is selected -->
    @if (this.organizationName && this.data.title !== 'TITLE.ORGANIZATIONS') {
      <div
        class="fx-fill fx-layout-row fx-justify-center fx-align-center">
        @if (logo) {
          <img [src]="logo" class="navbar-logo" [alt]="'Logo ' + organizationName">
        }
        <div id="organization-name" [ngClass]="{'fx-hide-lt-sm': logo}">{{ this.organizationName }}</div>
      </div>
    }
  </span>
  <!-- ============================================================== -->
  <!-- help popup menu -->
  <!-- ============================================================== -->
  <button #aide [matMenuTriggerFor]="helpMenu" [matTooltip]="'TOOLTIP.HELP' | translate" mat-icon-button
          (menuOpened)="onNavigation('TOOLTIP.HELP')">
    <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="help-icon"></mat-icon>
  </button>
  <mat-menu #helpMenu [overlapTrigger]="false" id="helpMenu" yPosition="below">
    <a [href]="['https://www.tbmaestro.com/guide-mya/']" [target]="['_blank']" mat-menu-item
       (click)="onNavigation('MENU.USER_GUIDE')">
      <mat-icon fontSet="mdi" fontIcon="mdi-book-open-variant"></mat-icon>
      <span>{{ 'MENU.USER_GUIDE' | translate }}</span>
    </a>
    <a [href]="['https://tbmaestro.atlassian.net/servicedesk']" [target]="['_blank']" mat-menu-item
       (click)="onNavigation('MENU.SERVICE_DESK')">
      <mat-icon fontSet="mdi" fontIcon="mdi-forum"></mat-icon>
      <span>{{ 'MENU.SERVICE_DESK' | translate }}</span>
    </a>
  </mat-menu>

  <!-- ============================================================== -->
  <!-- rights management popup menu -->
  <!-- ============================================================== -->
  @if (appManager.currentOrganization && accessManager.hasAccess(Permission.VIEW_CLIENT)) {
    <button #rights="matTooltip"
            [routerLink]="['/organization', appManager.currentOrganization?.id, 'clients']"
            [matTooltip]="'TOOLTIP.MANAGE_RIGHTS' | translate" mat-icon-button
            (click)="onNavigation('TOOLTIP.MANAGE_RIGHTS')">
      <mat-icon fontSet="mdi" fontIcon="mdi-shield-account" class="help-icon"></mat-icon>
    </button>
  }

  <!-- ============================================================== -->
  <!-- retool apps popup menu -->
  <!-- ============================================================== -->
  @if (appManager.currentOrganization && accessManager.hasAccess(Permission.VIEW_RETOOL_APP)) {
    @if (retoolApps$ | async; as retoolApps) {
      <button [matMenuTriggerFor]="retoolMenu"
              (menuOpened)="onNavigation('TOOLTIP.RETOOL_APP')"
              [matTooltip]="'TOOLTIP.RETOOL_APP' | translate" mat-icon-button
              (click)="onNavigation('TOOLTIP.RETOOL_APP')"
              [disabled]="!retoolApps?.length">
        <mat-icon fontSet="mdi" fontIcon="mdi-toolbox-outline" class="help-icon"></mat-icon>
      </button>
      <mat-menu #retoolMenu [overlapTrigger]="false" id="retoolMenu" yPosition="below">
        @for (retoolApp of retoolApps; track retoolApp?.id) {
          <button mat-menu-item (click)="onNavigation('MENU.RETOOL_APP')"
                  [routerLink]="['/organization', appManager.currentOrganization?.id, 'embedded-app', retoolApp.id]">
            <mat-icon fontSet="mdi" fontIcon="mdi-application-outline" [style]="{color: retoolApp.color}" class="msm"></mat-icon>
            <span>{{ retoolApp.name }}</span>
          </button>
        }
      </mat-menu>
    }
  }

  <!-- ============================================================== -->
  <!-- org popup menu -->
  <!-- ============================================================== -->
  @if (appManager.currentOrganization &&
  (accessManager.hasAccessToOrganization(appManager.currentOrganization?.id) || accessManager.isSuperAdmin()) &&
  (accessManager.hasAccess(Permission.MANAGE_CONFIG_ORGANIZATION) || accessManager.hasAccess(Permission.VIEW_RISK) ||
    accessManager.hasAccess(Permission.VIEW_CRV) || accessManager.hasAccess(Permission.VIEW_SNAPSHOT) ||
    accessManager.hasAccess(Permission.VIEW_DOCUMENT))) {
    <button #org="matTooltip"
            [matMenuTriggerFor]="orgMenu" [matTooltip]="'TOOLTIP.CONFIGURATION' | translate" mat-icon-button
            (menuOpened)="onNavigation('TOOLTIP.CONFIGURATION')">
      <mat-icon fontSet="mdi" fontIcon="mdi-cog" class="help-icon"></mat-icon>
    </button>
  }
  <mat-menu #orgMenu [overlapTrigger]="false" id="orgMenu" yPosition="below">
    @if (accessManager.hasAccess(Permission.MANAGE_CONFIG_ORGANIZATION)) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'general']"
        mat-menu-item (click)="onNavigation('MENU.ORG_GENERAL_INFO')">
        <mat-icon fontSet="mdi" fontIcon="mdi-image-text"></mat-icon>
        <span>{{ 'MENU.ORG_GENERAL_INFO' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAccess(Permission.VIEW_FIELD_CONFIG)) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'fields']"
        mat-menu-item (click)="onNavigation('MENU.ORG_CONFIG_FIELD')">
        <mat-icon fontSet="mdi" fontIcon="mdi-file-cog-outline"></mat-icon>
        <span>{{ 'MENU.ORG_CONFIG_FIELD' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAccess(Permission.MANAGE_CONFIG_ORGANIZATION)) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'storage']"
        mat-menu-item (click)="onNavigation('MENU.ORG_STORAGE_SPACE')">
        <mat-icon fontSet="mdi" fontIcon="mdi-database" class="msm"></mat-icon>
        <span>{{ 'MENU.ORG_STORAGE_SPACE' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAllNeededPermissions([Permission.MANAGE_CONFIG_ORGANIZATION, Permission.EDIT_BI_REPORT])) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'BI-reports']"
        mat-menu-item (click)="onNavigation('MENU.BI_REPORTS')">
        <mat-icon fontSet="mdi" fontIcon="mdi-file-chart"></mat-icon>
        <span>{{ 'MENU.BI_REPORTS' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAccess(Permission.VIEW_CRV)) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'crv']"
        mat-menu-item (click)="onNavigation('MENU.CRV_DETAILS')">
        <mat-icon fontSet="mdi" fontIcon="mdi-home-analytics"></mat-icon>
        <span>{{ 'MENU.CRV_DETAILS' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAccess(Permission.MANAGE_ORGANIZATION_CLASS)) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'organization-classes']"
        mat-menu-item (click)="onNavigation('MENU.ORGANIZATION_CLASSES')">
        <mat-icon fontSet="mdi" fontIcon="mdi-database-search"></mat-icon>
        <span>{{ 'MENU.ORGANIZATION_CLASSES' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAllNeededPermissions([Permission.MANAGE_CONFIG_ORGANIZATION, Permission.MANAGE_ASSET_TYPE])) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'types']"
        mat-menu-item (click)="onNavigation('MENU.ASSET_TYPES')">
        <mat-icon fontSet="mdi" fontIcon="mdi-office-building-cog-outline"></mat-icon>
        <span>{{ 'MENU.ASSET_TYPES' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAccess(Permission.VIEW_RISK)) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'risks']"
        mat-menu-item (click)="onNavigation('MENU.RISKS')">
        <mat-icon fontSet="mdi" fontIcon="mdi-alert"></mat-icon>
        <span>{{ 'MENU.RISKS' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAllNeededPermissions([Permission.EDIT_PARAMS_JMAP, Permission.VIEW_JMAP])) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'jmap']"
        mat-menu-item (click)="onNavigation('MENU.JMAP')">
        <mat-icon fontSet="mdi" fontIcon="mdi-map"></mat-icon>
        <span>{{ 'MENU.JMAP' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAllNeededPermissions([Permission.EDIT_PARAMS_CV, Permission.VIEW_CARTOVISTA])) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'cartovista']"
        mat-menu-item (click)="onNavigation('MENU.CARTOVISTA')">
        <mat-icon fontSet="mdi" fontIcon="mdi-map"></mat-icon>
        <span>{{ 'MENU.CARTOVISTA' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAccess(Permission.VIEW_SNAPSHOT)) {
      <button
        mat-menu-item
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'snapshots']"
        (click)="onNavigation('MENU.SNAPSHOTS')">
        <mat-icon fontSet="mdi" fontIcon="mdi-folder-multiple"></mat-icon>
        <span>{{ 'MENU.SNAPSHOTS' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAllNeededPermissions([Permission.MANAGE_VIRTUAL_TOUR, Permission.VIEW_VIRTUAL_TOUR])) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'virtual-tours']"
        mat-menu-item (click)="onNavigation('MENU.VIRTUAL_TOURS')">
        <mat-icon fontSet="mdi" fontIcon="mdi-home-map-marker"></mat-icon>
        <span>{{ 'MENU.VIRTUAL_TOURS' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAccess(Permission.VIEW_DOCUMENT)) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'files']"
        mat-menu-item (click)="onNavigation('MENU.FILE_REPOSITORY')">
        <mat-icon fontSet="mdi" fontIcon="mdi-file-cloud-outline"></mat-icon>
        <span>{{ 'MENU.FILE_REPOSITORY' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAllNeededPermissions([Permission.MANAGE_RETOOL_APP, Permission.VIEW_RETOOL_APP])) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'embedded-apps']"
        mat-menu-item (click)="onNavigation('MENU.RETOOL_APP')">
        <mat-icon fontSet="mdi" fontIcon="mdi-toolbox-outline"></mat-icon>
        <span>{{ 'MENU.RETOOL_APP' | translate }}</span>
      </button>
    }
    @if (accessManager.isSuperAdmin() || (accessManager.isUserRole(UserRoleEnum.ADMIN_TB) && accessManager.hasAccessToOrganization(appManager.currentOrganization?.id))) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'external-links']"
        mat-menu-item (click)="onNavigation('MENU.EXTERNAL_LINK')">
        <mat-icon fontSet="mdi" fontIcon="mdi-link-variant"></mat-icon>
        <span>{{ 'MENU.EXTERNAL_LINK' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAllNeededPermissions([Permission.VIEW_BI_REPORT])) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'analysis']"
        mat-menu-item (click)="onNavigation('MENU.ANALYSIS')">
        <mat-icon fontSet="mdi" fontIcon="mdi-file-chart"></mat-icon>
        <span>{{ 'MENU.ANALYSIS' | translate }}</span>
      </button>
    }
    @if (accessManager.hasAllNeededPermissions([Permission.MANAGE_WORKFLOW])) {
      <button
        [routerLink]="['/organization', appManager.currentOrganization?.id, 'configuration', 'workflows']"
        mat-menu-item (click)="onNavigation('MENU.WORKFLOW')">
        <mat-icon fontSet="mdi" fontIcon="mdi-vector-polyline"></mat-icon>
        <span>{{ 'MENU.WORKFLOW' | translate }}</span>
      </button>
    }
  </mat-menu>
  <!-- ============================================================== -->
  <!-- Profile popup menu -->
  <!-- ============================================================== -->
  <button [matMenuTriggerFor]="myPages"
          [matTooltip]="'TOOLTIP.MY_PAGES' | translate"
          class="profile-pic">
    @if (authService.user$ | async; as user) {
      <img class="profile-picture"
           [ngSrc]="user.picture"
           width="40"
           height="40"
           alt="{{'TOOLTIP.PROFILE_PICTURE' | translate}}">
    }
  </button>
  <mat-menu #myPages [overlapTrigger]="false" id="profileMenu" yPosition="below">
    <!-- My profile -->
    <button mat-menu-item (click)="openProfilePage()">
      <mat-icon fontSet="mdi" fontIcon="mdi-account-box"></mat-icon>
      <span>{{ 'MENU.MY_PROFILE' | translate }}</span>
    </button>

    @if (appManager.currentOrganization !== undefined) {
      <!-- My user report -->
      <restricted-menu-item [preconditions]="true"
                            [routerLink]="['/organization', appManager.currentOrganization?.id, 'user-report']">
        <mat-icon fontSet="mdi" fontIcon="mdi-file-document"></mat-icon>
        <span>{{ 'MENU.MY_USER_REPORT' | translate }}</span>
      </restricted-menu-item>

      <!-- My subscription -->
      <restricted-menu-item [permissions]="[Permission.VIEW_SUBSCRIPTION]"
                            [preconditions]="true"
                            [routerLink]="['/organization', appManager.currentOrganization?.id, 'subscription']">
        <mat-icon fontSet="mdi" fontIcon="mdi-credit-card"></mat-icon>
        <span>{{ 'MENU.MY_SUBSCRIPTION' | translate }}</span>
      </restricted-menu-item>
    }

    <!-- Logout -->
    <button (click)="logout()" mat-menu-item>
      <mat-icon fontSet="mdi" fontIcon="mdi-logout"></mat-icon>
      <span>{{ 'MENU.LOGOUT' | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>
